import { Button, Table, Typography } from 'antd';

import { ConfirmDeletingElement } from '@app/components/ConfirmDeletingElement';
import { COLUMNS } from '@app/components/RecordModal/components/TechnologicalMap/components/FinalTechMapTable/data';
import {
  useFinalTechMapTable,
  useFinalTechMapTableEffect,
} from '@app/components/RecordModal/components/TechnologicalMap/components/FinalTechMapTable/hooks';

import '@app/components/RecordModal/components/TechnologicalMap/components/FinalTechMapTable/styles/FinalTechMapTable.desktop.scss';

const { Title, Text } = Typography;

export const FinalTechMapTable: React.FC = () => {
  const {
    isRecordTechnologicalMapLoading,
    recordTechnologicalMapData,
    refetchRecordTechnologicalMap,
  } = useFinalTechMapTableEffect();
  const {
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    handleTechnologicalMapCancel,
    isDeleteTechnologicalMapLoading,
  } = useFinalTechMapTable({
    recordTechnologicalMapData,
    refetchRecordTechnologicalMap,
  });

  return (
    <>
      {recordTechnologicalMapData?.Id && (
        <Title level={5}>
          Технологическая карта №{' '}
          {String(recordTechnologicalMapData.Id).padStart(6, '0')}
        </Title>
      )}

      {recordTechnologicalMapData?.TimeApplied && (
        <Text type="secondary">
          Применена{' '}
          {new Date(recordTechnologicalMapData.TimeApplied).toLocaleString()}
        </Text>
      )}

      <Table
        dataSource={recordTechnologicalMapData?.Operations?.map(
          (operation) => ({
            ...operation,
            key: operation.Id,
          })
        )}
        columns={COLUMNS}
        pagination={false}
        bordered
        loading={isRecordTechnologicalMapLoading}
      />

      {recordTechnologicalMapData?.Operations?.length && (
        <Button
          type="primary"
          className="cancel-tech-map-button"
          onClick={() => {
            setIsDeleteModalOpen(true);
          }}
          loading={isDeleteTechnologicalMapLoading}
        >
          Отменить тех. карту
        </Button>
      )}

      <ConfirmDeletingElement
        modalOpen={isDeleteModalOpen}
        setModalOpen={setIsDeleteModalOpen}
        handleDelete={handleTechnologicalMapCancel}
        content="Вы уверены, что хотите отменить применение технологической карты?"
        title="Отмена применения технологической карты"
      />
    </>
  );
};
